var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{attrs:{"xs-12":"","sm-6":"","md-6":"","lg-6":""}},[_c('v-card',{attrs:{"width":"100%"}},[_c('v-card-text',{staticClass:"text--primary"},[_c('div',[_vm._v(_vm._s(_vm.titulo))])]),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","block":""},on:{"click":_vm.irALaRuta}},[_vm._v(" "+_vm._s(_vm.titulo)+" ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }